import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { Api } from '../libs/api'
import MiddleBanner from './middleBanner'
import { getCookie } from 'common/util/cookie'
import { itemImage, numberFormat } from 'common/util/util'
import { setIsLogin, setUserInfo } from '../libs/action'
import Search from './search'

class Head extends React.Component {
    constructor(props) {
        super(props)
        this.loginRef = React.createRef()
        this.state = {
            UserInfo: {},
            isLogin: false,
            isBookMarkLayer: false,
            happyShoppingShopNo: [1, 2, 3, 4, 9004, 9036],
        }
        this.domain = window.location.hostname.split('.')[0] // domain
        if (window.isSearch) this.domain = 'search'
    }

    componentDidMount() {
        if (this.loginRef.current) {
            this.loginRef.current.style.display = 'none'
        }

        let authToken = getCookie('auth_token')
        if (authToken) {
            Api.getUserInfo().then((rst) => {
                if (rst.data.code === 200) {
                    if (this.loginRef.current) {
                        this.loginRef.current.style.display = 'contents'
                    }
                    if (rst.data.isLogin) {
                        this.setState({ isLogin: rst.data.isLogin, userInfo: rst.data.result })
                        this.props.setIsLogin(rst.data.isLogin)
                        this.props.setUserInfo(rst.data.result)
                    }
                }
            })
        }

        if (!authToken) {
            this.loginRef.current.style.display = 'contents'
        }
    }

    getEstimateItem(v) {
        return (
            <div className="HTTBTCTSILItem">
                <span className="HTTBTCTSILIThumb">{itemImage(v.thumbnail, v.full_item_name, 200)}</span>
                <div className="HTTBTCTSILIInfo">
                    <strong className="HTTBTCTSILIICorpname">[{v.cate_name}]</strong>
                    <span className="HTTBTCTSILIIName">{v.full_item_name}</span>
                    {v.price_low === 0 ? (
                        <span className="HTTBTCTSILIIPrice" style={{ color: '#f60' }}>
                            가격 비교 예정
                        </span>
                    ) : (
                        <span className="HTTBTCTSILIIPrice">{numberFormat(v.price_low)} 원</span>
                    )}
                </div>
            </div>
        )
    }

    getCartItem(v) {
        return (
            <div className="HTTBTCTSILItem">
                <span className="HTTBTCTSILIThumb">{itemImage(v.thumbnail, v.full_item_name, 200)}</span>
                <div className="HTTBTCTSILIInfo">
                    <strong className="HTTBTCTSILIICorpname">{v.mall_name}</strong>
                    <span className="HTTBTCTSILIIName">{v.full_item_name}</span>
                </div>
            </div>
        )
    }

    onBookMark() {
        if (this.state.isBookMarkLayer) {
            this.setState({ isBookMarkLayer: false })
        } else {
            this.setState({ isBookMarkLayer: true })
        }
    }

    bookMarkLayer() {
        return (
            <table id="lyrPop" className="bgdark">
                <tbody>
                    <tr>
                        <td>
                            <div className="PopMain artPop">
                                <strong>
                                    <font className="pfClr1">Ctrl + D</font> 키를 눌러
                                    <br />
                                    즐겨찾기에 등록하실 수 있습니다.
                                </strong>
                                <div className="popDefBtns">
                                    <button className="icon-X_close" onClick={() => this.onBookMark()} />
                                    <button className="confBtn" onClick={() => this.onBookMark()}>
                                        확인
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    /**
     * 시즌(이벤트) 로고가 없으면, 기본 로고를 노출되도록 설계되어 있습니다.
     * @param src : 시즌로고(이벤트로고) 경로
     * @param errSrc : 기본로고(미니샵별로고) 경로
     * @param title
     * @returns {JSX.Element}
     */
    image(src, errSrc) {
        /**
         * 페이지 로딩 시 타이틀 텍스트가 먼저 노출되면서 마치 오류와 같이 보이는 증상이 있음
         * 이를 방지하기 위해 alt를 빈값으로 처리합니다.
         */
        return <img src={src} onError={(e) => (e.target.src = errSrc)} alt="" />
    }

    /**
     * 미니샵 idx_b_manager가 행복쇼핑 관련 미니샵인지 확인합니다.
     * 만약 idx_b_manager가 [1,2,3,4,9004,9036] 또는 undefined인 경우에는 행복쇼핑 관련 미니샵입니다.
     * @param miniShopInfo
     * @returns {boolean}
     */
    isHappyShopping(miniShopInfo) {
        if (
            this.state.happyShoppingShopNo.includes(miniShopInfo.idx_b_manager) ||
            miniShopInfo.idx_b_manager === undefined
        ) {
            return true
        } else {
            return false
        }
    }

    validateLogo(miniShopInfo, mainLogo) {
        let imageSeasonLogo = ''
        let imageDesktopLogo = ''
        let imageFixLogo = ''
        let logoImg = null

        if (Object.keys(miniShopInfo).length === 0) {
            let { seasonLogo, desktopLogo, desktopFixLogo } = mainLogo
            imageSeasonLogo = seasonLogo
            imageDesktopLogo = desktopLogo
            imageFixLogo = desktopFixLogo
        } else {
            let { image_logo_season, image_logo_desktop, image_logo_fix } = miniShopInfo
            imageSeasonLogo = image_logo_season
            imageDesktopLogo = image_logo_desktop
            imageFixLogo = image_logo_fix
        }

        if (this.isHappyShopping(miniShopInfo)) {
            /**
             * 행복쇼핑 관련 미니샵인 경우에는 시즌(이벤트) 로고를 우선 노출하고 없는 경우 기본 로고를 노출합니다.
             * @type {JSX.Element}
             */
            logoImg = this.image(imageSeasonLogo, imageDesktopLogo)
        } else {
            /**
             * 행복쇼핑 관련 미니샵이 아닌 경우에는 미니샵별로고를 노출합니다.
             * toto : 추후에는 미니샵도 시즌(이벤트) 로고를 사용할 수 있도록 수정해야 합니다.
             *
             * AS-IS :
             * <img src="행복쇼핑 이벤트 로고" onError="각 미니샵별 로고" />
             *
             * TO-BE :
             * <img src="각 미니샵별 이벤트 로고" onError="각 미니샵별 로고" />
             * @type {JSX.Element}
             */
            logoImg = this.image(imageDesktopLogo, imageDesktopLogo)
        }

        return { imageFixLogo, logoImg }
    }

    // Header 부분 로그인 정보 확인 전 로그인 태그 잠시 노출되는 부분 수정
    validateLogin(miniShopInfo) {
        const userInfo = this.state.userInfo
        const mallNum = miniShopInfo && miniShopInfo.mall_num && miniShopInfo.mall_num //mallNum->0 행복쇼핑
        let userName = ''
        let estimateCount = 0
        let estimateList = []
        let cartCount = 0
        let cartList = []

        if (this.state.isLogin) {
            userName = userInfo.user_name
            estimateCount = userInfo.estimate.count
            estimateList = userInfo.estimate.list
            cartCount = userInfo.cart.count
            cartList = userInfo.cart.list
        }
        return { userInfo, mallNum, userName, estimateCount, estimateList, cartCount, cartList }
    }

    render() {
        let { fixMode, miniShopInfo, mainLogo } = this.props
        const { imageFixLogo, logoImg } = this.validateLogo(miniShopInfo, mainLogo)
        const { mallNum, userName, estimateCount, estimateList, cartCount, cartList } = this.validateLogin(miniShopInfo)

        return (
            <div className="HTopArea">
                {/* <!-- HTTop --> */}
                <div className="HTTop">
                    <div className="HTTBody ADTWrap">
                        {/*미니샵이고 행복쇼핑이 아니면 노출*/}
                        {window.isMiniShop && mallNum !== 0 && (
                            <a
                                href={process.env.REACT_APP_WWW_URL}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="HhomeBtn"
                            >
                                <img
                                    src={`${process.env.REACT_APP_CDN_IMG}/img_static/img/tmp/mlogo.png`}
                                    alt="행복쇼핑"
                                />
                            </a>
                        )}
                        {window.isStdpc && (
                            <ul className="top_nav_local">
                                <li className="home">
                                    <a href={process.env.REACT_APP_WWW_URL}>
                                        <i className="icon-home1"></i>
                                    </a>
                                </li>
                                <li className="list">
                                    <a href={process.env.REACT_APP_PC_URL}>PC견적</a>
                                </li>
                                <li className="list">
                                    <a href={process.env.REACT_APP_STDPC_URL} className="active">
                                        조립PC
                                    </a>
                                </li>
                                <li className="list">
                                    <a href={process.env.REACT_APP_DEAL_URL}>행복핫딜</a>
                                </li>
                                <li className="list">
                                    <a href={process.env.REACT_APP_EVENT_URL}>쇼핑기획전</a>
                                </li>
                            </ul>
                        )}
                        <div className="HTTBTopInfo">
                            {this.state.isLogin && (
                                <strong className="HTTBTCell HTTUser">
                                    <a href={process.env.REACT_APP_MY_URL}>{userName}</a>
                                    <em>님</em>{' '}
                                    <a href={`${process.env.REACT_APP_API2_URL}/logout`} className="HTTLogBtn">
                                        로그아웃
                                    </a>
                                </strong>
                            )}
                            {this.state.isLogin === false && (
                                <div ref={this.loginRef}>
                                    <strong className="HTTBTCell HTTUser">
                                        <a href={process.env.REACT_APP_SSO_URL} className="HTTLogBtn">
                                            로그인
                                        </a>
                                    </strong>
                                    <span className="HTTBTCell HTTJoin">
                                        <a href={`${process.env.REACT_APP_SSO_URL}/join`}>회원가입</a>
                                    </span>
                                </div>
                            )}
                            <div className="HTTBTCell HTTMy">
                                <a href={`//my2.pping.${process.env.REACT_APP_TLD}/`}>
                                    <span className="HTTBTCTit">마이쇼핑</span>
                                </a>
                                <ul className="HTTBTCTSub">
                                    <li>
                                        <a href={`//my2.pping.${process.env.REACT_APP_TLD}/main/order_check`}>
                                            구매·배송 조회
                                        </a>
                                    </li>
                                    <li>
                                        <a href={`//my2.pping.${process.env.REACT_APP_TLD}/main/cbe`}>취소·환불 조회</a>
                                    </li>
                                    <li className="HTTSLine">
                                        <a href={`//point2.pping.${process.env.REACT_APP_TLD}/`}>해피 포인트</a>
                                    </li>
                                    {/* <li><a href="http://event.minishop.pping.${process.env.REACT_APP_TLD}/main/coupon">할인 쿠폰</a></li> */}
                                    <li className="HTTSLine">
                                        <a href={`//my2.pping.${process.env.REACT_APP_TLD}/zzim`}>찜한 상품</a>
                                    </li>
                                    <li>
                                        <a href={`//my2.pping.${process.env.REACT_APP_TLD}/estimate_print`}>
                                            찜한 견적
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            // href={`https://www3.pping.${process.env.REACT_APP_TLD}/partner/?sch_cate=&sch_auth_seller=zzim&sch_sort=name&page=1&sch_value=`}
                                            href={`${process.env.REACT_APP_WWW_URL}/partner?sch_auth_seller=zzim`}
                                        >
                                            찜한 쇼핑몰
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="HTTBTCell HTTServicecenter">
                                <a href={process.env.REACT_APP_HELP_URL}>
                                    <span className="HTTBTCTit">고객센터</span>
                                </a>
                                <ul className="HTTBTCTSub">
                                    <li>
                                        <a href={`${process.env.REACT_APP_HELP_URL}/faq/1/1`}>자주묻는 질문</a>
                                    </li>
                                    <li>
                                        <a href={`${process.env.REACT_APP_HELP_URL}/qna/write`}>1:1 문의하기</a>
                                    </li>
                                    <li>
                                        <a href={`${process.env.REACT_APP_HELP_URL}/notice`}>공지사항</a>
                                    </li>
                                    <li>
                                        <a href={`${process.env.REACT_APP_HELP_URL}/guideClaim`}>환불/교환 안내</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="HTTBTCell HTTEstimate">
                                <a href={`${process.env.REACT_APP_CART_URL}/est`}>
                                    <span className="HTTBTCTit">
                                        상품견적 <em className="cnt">{estimateCount}</em>
                                    </span>
                                </a>
                                {estimateCount > 0 && (
                                    <div className="HTTBTCTSub">
                                        <ul>
                                            {estimateList.map((v, i) => {
                                                if (i > 5) return false
                                                return (
                                                    <li key={i}>
                                                        {v.href ? (
                                                            <a href={v.href} target="_blank">
                                                                {this.getEstimateItem(v)}
                                                            </a>
                                                        ) : (
                                                            <>{this.getEstimateItem(v)}</>
                                                        )}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        <a href={`${process.env.REACT_APP_CART_URL}/est`} className="HTTBTCTSAllBtn">
                                            상품견적 전체보기
                                            <i className="icon-angle-right" />
                                        </a>
                                    </div>
                                )}
                            </div>
                            <div className="HTTBTCell HTTBasket">
                                <a href={process.env.REACT_APP_CART_URL}>
                                    <span className="HTTBTCTit">
                                        장바구니 <em className="cnt">{cartCount}</em>
                                    </span>
                                </a>
                                {cartCount > 0 && (
                                    <div className="HTTBTCTSub">
                                        <ul>
                                            {cartList.map((v, i) => {
                                                if (i > 5) return false
                                                return (
                                                    <li key={i}>
                                                        {v.href ? (
                                                            <a href={v.href} target="_blank">
                                                                {this.getCartItem(v)}
                                                            </a>
                                                        ) : (
                                                            <>{this.getCartItem(v)}</>
                                                        )}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                        <a href={process.env.REACT_APP_CART_URL} className="HTTBTCTSAllBtn">
                                            장바구니 전체보기
                                            <i className="icon-angle-right" />
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- // HTTop --> */}
                <div className="HTMain ADTWrap">
                    <figure className="HTMCi HTMObj">
                        {fixMode ? (
                            <span>
                                <a href={process.env.REACT_APP_WWW_URL}>
                                    <img
                                        src={`${imageFixLogo}`}
                                        alt="행복쇼핑 CI"
                                        onError={`${process.env.REACT_APP_CDN_IMG}/img_static/img_logo/1/1_36_36.png`}
                                    />
                                </a>
                            </span>
                        ) : window.isMiniShop && mallNum !== 0 ? (
                            <a href={process.env.REACT_APP_MINISHOP_URL + '/' + window.shopID}>{logoImg}</a>
                        ) : (
                            <a href={process.env.REACT_APP_WWW_URL}>{logoImg}</a>
                        )}
                    </figure>
                    {this.domain === 'search' ? (
                        <Switch>
                            <Route
                                path="/:tabs/:keyword/*"
                                render={(props) => <Search {...props} domain={this.domain} />}
                            />
                            <Route
                                path="/:tabs/:keyword"
                                render={(props) => <Search {...props} domain={this.domain} />}
                            />
                            <Route path="*" render={(props) => <Search {...props} domain={this.domain} />} />
                        </Switch>
                    ) : (
                        <Route path="*" render={(props) => <Search {...props} domain={this.domain} />} />
                    )}
                    <MiddleBanner headerRightBanner={this.props.headerRightBanner} />
                </div>
                {this.state.isBookMarkLayer && this.bookMarkLayer()}
            </div>
        )
    }
}

let stateData = (state) => {
    return {
        userInfo: state.user.userInfo,
        isLogin: state.user.isLogin,
    }
}

let dispatchData = (dispatch) => {
    return {
        setUserInfo: (userInfo) => dispatch(setUserInfo(userInfo)),
        setIsLogin: (isLogin) => dispatch(setIsLogin(isLogin)),
    }
}

export default connect(stateData, dispatchData)(Head)



// WEBPACK FOOTER //
// ./src/header/component/head.js